import { Main } from "components/pages";
import { TableAddressees } from "components/tables";
import { IAddressee } from "config/interfaces";

export default function Addressees({ newAddressee, data }: IAddressee.Form) {
  return (
    <>
      {/* <PageHeader title="Gerenciar Destinatários" /> */}

      <Main>
        <section>
          <TableAddressees />
        </section>
      </Main>
    </>
  );
}
